<template>
  <div class="checkoutpage-component">
    <div class="checkout-page__body" v-if="order && order.status == 'new'">
      <div class="checkout-page__content">
        <div class="checkout-page__forms">
          <div class="checkout-form" v-if="order">
            <div
              :class="{ 'checkout-form-group--expanded': order.stage == 'start' }"
              class="checkout-form__group checkout-form-group">
              <div class="checkout-form-group__header">
                <div class="checkout-form-group__name">Покупатель</div>
              </div>
              <div
                :class="{ 'checkout-form-group__body--expanded': order.stage == 'start' }"
                class="checkout-form-group__body">

                <ul class="checkout-form-group__tabs client-info-tabs">
                  <li :class="{ 'client-info-tabs__item--active': activeTab == 'CheckoutPersonalForm' }"
                    class="client-info-tabs__item client-tab">
                    <button @click="changeTab('CheckoutPersonalForm', 'personal')"
                      :class="{ 'client-tab__btn--active': activeTab == 'CheckoutPersonalForm' }"
                      class="client-tab__btn">Физическое лицо</button>
                  </li>
                  <li :class="{ 'client-info-tabs__item--active': activeTab == 'CheckoutCorporateForm' }"
                    class="client-info-tabs__item client-tab">
                    <button @click="changeTab('CheckoutCorporateForm', 'corporate')"
                      :class="{ 'client-tab__btn--active': activeTab == 'CheckoutCorporateForm' }"
                      class="client-tab__btn">Юридическое лицо</button>
                  </li>
                </ul>

                <component :is="activeTab" :order="order" :errors="errors"></component>

                <div class="checkout-form-group__actions">
                  <button @click="saveOrder('delivery')"
                    class="btn btn-primary checkout-form-group__next-btn">Далее</button>
                </div>
              </div>

              <div
                v-if="order.stage != 'start'"
                class="checkout-form-group__filled-body filled-fields">
                <div class="filled-fields__item">{{ order.first_name }}</div>
                <div class="filled-fields__item">{{ order.phone }}</div>
                <div class="filled-fields__item">{{ order.email }}</div>
                <div class="filled-fields__actions">
                  <button
                    @click="saveOrder('start')"
                    class="btn btn-outline--tertiary edit-checkout-btn">
                    <i class="fa fa-pencil edit-checkout-btn__icon"></i>
                    <span class="edit-checkout-btn__text">Изменить</span>
                  </button>
                </div>
              </div>
            </div>

            <div :class="{ 'checkout-form-group--expanded': order.stage == 'delivery' }"
              class="checkout-form__group checkout-form-group">
              <div class="checkout-form-group__header">
                <div class="checkout-form-group__name">Способ получения</div>
              </div>
              <div
                :class="{ 'checkout-form-group__body--expanded': order.stage == 'delivery' }"
                class="checkout-form-group__body">

                <checkout-delivery-form
                  v-if="order && order.id"
                  @on-select="selectDelivery"
                  :order="order"
                  :errors="errors"></checkout-delivery-form>

                <div class="checkout-form-group__actions">
                  <button
                    @click="saveOrder('payment')"
                    class="btn btn-primary checkout-form-group__next-btn">Далее</button>
                </div>
              </div>

              <div
                v-if="order.stage != 'delivery' && order.delivery"
                class="checkout-form-group__filled-body filled-fields">
                <div class="filled-fields__item">{{ order.delivery_instance.name }}</div>
                <div class="filled-fields__actions">
                  <button
                    @click="saveOrder('delivery')"
                    class="btn btn-outline--tertiary edit-checkout-btn">
                    <i class="fa fa-pencil edit-checkout-btn__icon"></i>
                    <span class="edit-checkout-btn__text">Изменить</span>
                  </button>
                </div>
              </div>

            </div>

            <div :class="{ 'checkout-form-group--expanded': order.stage == 'payment' }"
              class="checkout-form__group checkout-form-group">
              <div class="checkout-form-group__header">
                <div class="checkout-form-group__name">Способ оплаты</div>
              </div>
              <div
                :class="{ 'checkout-form-group__body--expanded': order.stage == 'payment' }"
                class="checkout-form-group__body">

                <checkout-payment-form
                  v-if="order && order.id"
                  @on-select="selectPayment"
                  :order="order"
                  :errors="errors"></checkout-payment-form>

                <div class="checkout-form-group__actions">
                  <button
                    v-if="order.payment_code != 'ONLINE'"
                    @click="saveOrder('finish')"
                    class="btn btn-info checkout-form-group__complete-btn">Отправить заказа</button>
                  <button
                    v-if="order.payment_code == 'ONLINE'"
                    @click="saveOrder('to_bank')"
                    class="btn btn-success checkout-form-group__complete-btn">Оплатить онлайн</button>
                </div>

              </div>


              <div
                v-if="order.stage != 'payment' && order.payment"
                class="checkout-form-group__filled-body filled-fields">
                <div class="filled-fields__item">{{ order.payment_instance.name }}</div>
                <div class="filled-fields__actions">
                  <button
                    @click="saveOrder('payment')"
                    class="btn btn-outline--tertiary edit-checkout-btn">
                    <i class="fa fa-pencil edit-checkout-btn__icon"></i>
                    <span class="edit-checkout-btn__text">Изменить</span>
                  </button>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="checkout-page__aside">
        <div v-if="order && order.request_cart" class="summary-cart-info summary-cart-info--checkout-page">
          <div class="summary-cart-info__checkout-header">
            Ваш заказ
          </div>

          <div class="summary-cart-info__part summary-cart-info__part--products">
            <div class="summary-cart-info__block-title">Корзина</div>
            <div class="summary-cart-info__part-content">
              <div class="summary-products">

                <div class="summary-products__row">
                  <div class="summary-products__label">Товары ({{ order.request_cart.counts }})</div>
                  <div class="summary-products__price">{{ formatNumberWithSpaces(order.request_cart.raw_summary) }} руб.
                  </div>
                </div>

                <div v-if="order.request_cart.profit_cart" class="summary-products__row">
                  <div class="summary-products__label">Скидка</div>
                  <div class="summary-products__price summary-products__price--sale">-{{
                    formatNumberWithSpaces(order.request_cart.profit_cart) }} руб.</div>
                </div>

              </div>
            </div>
          </div>

          <div class="summary-cart-info__part summary-cart-info__part--products">
            <div class="summary-cart-info__block-title">Доставка</div>
            <div class="summary-cart-info__part-content">
              <div class="summary-products">

                <div
                  v-if="order.delivery_instance"
                  class="summary-products__row" >
                  <div class="summary-products__label">
                    {{ order.delivery_instance.name }}
                  </div>
                  <div
                    v-if="order.delivery_instance.calculated_price"
                    class="summary-products__price">{{ formatNumberWithSpaces(order.delivery_instance.calculated_price) }} руб.</div>
                  <div
                    v-if="!order.delivery_instance.calculated_price"
                    class="summary-products__price">Без доплат</div>
                </div>

              </div>
            </div>
          </div>

          <div
            v-if="order.summary_with_delivery"
            class="summary-cart-info__part summary-cart-info__part--summary-payment">
            <div class="summary-cart-info__row summary-cart-price">
              <div class="summary-cart-price__label">К оплате</div>
              <div class="summary-cart-price__value">{{ formatNumberWithSpaces(order.summary_with_delivery) }} руб.</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="checkout-page__body" v-if="order && ['sended', 'pending', 'payed', 'process', 'completed', 'canceled', 'returned'].includes(order.status)">
      <div class="checkout-page__fullpage-text">
        <p>Ваш заказ успешно отправлен! Менеджер свяжется с вами для уточнения деталей доставки и оплаты.</p>
        <div class="checkout-page__order-info order-info">
          <div class="order-info__block">

            <div class="order-info__password-link" v-if="order.link_password ">
              <div class="order-info__password-link-label">Ссылка на заказ:</div>
              <div class="order-info__password-link-value">{{ order.get_absolute_url }}</div>
              
              <button
                title="Скопировать ссылку на заказ"
                type="button"
                v-if="!copied"
                @click="getPasswordLink()"
                class="order-info__copy-link">
                  <i class="fa fa-copy"></i>
                </button>
                <button
                title="Скопировать ссылку на заказа"
                type="button"
                v-if="copied"
                @click="getPasswordLink()"
                class="order-info__copy-link order-info__copy-link--success">
                  <i class="fa fa-check"></i>
                </button>
            </div>

            <dl class="order-info__chars">

              <dt class="order-info__char-label">Статус</dt>
              <dd
                :class="'order-info__char-value--'+order.status"
                class="order-info__char-value">{{ order.get_status_display }}</dd>
                
              <dt class="order-info__char-label">Номер заказа</dt>
              <dd class="order-info__char-value">{{ order.order_number }}</dd>
              <dt class="order-info__char-label">Дата</dt>
              <dd class="order-info__char-value">{{ order.created_at | moment("D MMM YYYY") }}</dd>
              
              <dt class="order-info__char-label">Стоимость товаров</dt>
              <dd class="order-info__char-value">{{ formatNumberWithSpaces(order.cart_summary) }} руб.</dd>
              <dt class="order-info__char-label">Сумма с доставкой</dt>
              <dd class="order-info__char-value">{{ formatNumberWithSpaces(order.summary_with_delivery) }} руб.</dd>
            </dl>

            <div
              v-if="order.status == 'pending' && order.payment_form_url"
              class="order-info__pay-action">
              <a :href="order.payment_form_url" class="btn btn-primary">Оплатить онлайн</a>
            </div>

          </div>
          
          <div
            v-if="order.delivery_instance"
            class="order-info__delivery order-info__block">
            <h2 class="order-info__block-name">Доставка</h2>
            <dl class="order-info__chars">
              <dt class="order-info__char-label">{{ order.delivery_instance.name }}</dt>
              <dd class="order-info__char-value">{{ order.delivery_instance.help_text }}</dd>
            </dl>
          </div>

          <div
            v-if="order.payment_instance"
            class="order-info__delivery order-info__block">
            <h2 class="order-info__block-name">Оплата</h2>
            <dl class="order-info__chars">
              <dt class="order-info__char-label">{{ order.payment_instance.name }}</dt>
              <dd class="order-info__char-value">{{ order.payment_instance.help_text }}</dd>
            </dl>
          </div>

          <div
            v-if="order.products"
            class="order-info__products order-info__block cart-products">
            <h2 class="order-info__block-name">Товары</h2>
            <div class="cart-products__items">
              <div
                v-for="item in order.products" :key="'cart_item'+item.id"
                class="cart-products__item">
                <div class="cart-product-item">
                  <div class="cart-product-item__icon">
                    <img
                      :src="baseUrl+item.thumbnail"
                      :alt="item.name" class="cart-product-item__img" />
                  </div>
                  <div class="cart-product-item__content">
                    <div class="cart-product-item__main-info">
                      <div class="cart-product-item__name">
                        <a
                          :href="item.get_absolute_url"
                          target="_blank"
                          class="cart-product-item__link">{{ item.name }}</a>
                      </div>
                      <ul class="cart-product-item__labels">
                        <li
                          v-if="item.sale_percent"
                          class="cart-product-item__label product-label product-label--sale">
                          <span class="product-label__text product-label__text--sale">-{{ item.sale_percent.toFixed(0) }}%</span>
                        </li>
                        
                      </ul>
                    </div>

                    <div class="cart-product-item__price-area">
                      <div class="cart-product-item__price">{{ formatNumberWithSpaces(item.total_price.toFixed(0)) }} руб.</div>
                      <div
                        v-if="item.profit"
                        class="cart-product-item__price-raw">{{ formatNumberWithSpaces(item.raw_total_price.toFixed(0)) }} руб.</div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import axios from 'axios'

import { settings } from '../../variables'

import UtilsMixin from '../../vue_mixins/UtilsMixin.vue'

import CheckoutPersonalForm from './CheckoutPersonalForm.vue'
import CheckoutCorporateForm from './CheckoutCorporateForm.vue'
import CheckoutDeliveryForm from './CheckoutDeliveryForm.vue'
import CheckoutPaymentForm from './CheckoutPaymentForm.vue'

export default {

  name: 'CheckoutPage',

  mixins: [UtilsMixin],

  components: {
    CheckoutPersonalForm,
    CheckoutCorporateForm,
    CheckoutDeliveryForm,
    CheckoutPaymentForm
  },

  props: {
    password: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      baseUrl: settings.apiBaseUrl,
      order: null,
      activeTab: 'CheckoutPersonalForm',
      errors: {},
      copied: false
    }
  },

  mounted() {
    
    if (this.password) {
      this.getExistOrder()
    } else {
      this.getProcessingOrder()
    }
    
  },

  methods: {

    selectDelivery (daliveryItem) {
      this.order.delivery = daliveryItem.id
      this.saveOrder('delivery')
    },

    selectPayment (paymentItem) {
      this.order.payment = paymentItem.id
      this.saveOrder('payment')
    },

    saveOrder(nextStage) {

      if (this.order.link_password) {

        axios.put(
          `/checkout/api/order/status/`,
          this.order, {
            params: {
              next_stage: nextStage,
              p: this.order.link_password
            }
          })
          .then(response => {
            this.order = response.data
            this.errors = {}

            if (this.order.status == 'sended' && !this.password) {
              window.location.href = `${this.order.get_absolute_url}`
            }

            if (this.order.status == 'pending' && this.order.payment_form_url) {
              window.location.href = this.order.payment_form_url
            }

          })
          .catch(error => {
            this.errors = error.response.data
          })

      } else {
        axios.post(`/checkout/api/order/process/`, this.order, {params: {next_stage: nextStage}})
          .then(response => {
            this.order = response.data
            this.errors = {}
          })
          .catch(error => {
            this.errors = error.response.data
          })
      }
    },

    getProcessingOrder() {
      axios.get(`/checkout/api/order/process/?timestamp=${new Date().getTime()}`).then(
        response => {
          this.order = response.data

          if (this.order.status == 'pending' && this.order.payment_form_url) {
            window.location.href = this.order.payment_form_url
          }

          if (this.order.client_type) {
            switch (this.order.client_type) {
              case 'personal':
                this.activeTab = 'CheckoutPersonalForm'
              case 'corporate':
                this.activeTab = 'CheckoutCorporateForm'
              default:
                this.activeTab = 'CheckoutPersonalForm'
                this.order.client_type = 'personal'
            }
          } else {
            this.order.client_type = 'personal'
          }
        }
      )
    },

    getExistOrder() {
      axios.get(`/checkout/api/order/status/`, {params: {p: this.password}}).then(
        response => {
          this.order = response.data

          if (this.order.status == 'pending' && this.payment_form_url) {
            window.location.href = this.payment_form_url
          }

        }
      )
    },

    changeTab(componentName, clientType) {
      this.activeTab = componentName
      this.order.client_type = clientType
    },

    getPasswordLink () {
      var link = this.order.get_absolute_url
      navigator.clipboard.writeText(link).then(() => {

        this.copied = true
        
        setTimeout(() => {
          this.copied = false
        }, 2000)

      }, err => {
        console.error('Async: Could not copy text: ', err)
      })
    }
  },

}
</script>


<style lang="scss"></style>
